import { useQueries, useQuery } from "hooks";
import { getQueryKey } from "utils";
import { Address, Company, ShareCapital } from "types";

const getAddressItems = (address?: Address) => [
  {
    label: "common.country",
    value: address?.country,
  },
  {
    label: "address.unitNumber",
    value: address?.unitNumber,
  },
  {
    label: "address.streetNumber",
    value: address?.streetNumber,
  },
  {
    label: "address.streetName",
    value: address?.streetName,
  },
  {
    label: "address.streetType",
    value: address?.streetType,
  },
  {
    label: "address.boxType",
    value: address?.boxType,
  },
  {
    label: "address.boxNumber",
    value: address?.boxNumber,
  },
  {
    label: "address.suburb",
    value: address?.suburb,
  },
  {
    label: "address.state",
    value: address?.state,
  },
  {
    label: "address.postcode",
    value: address?.postcode,
  },
];

export const useCompanyAddresses = (company: Company) => {
  const [
    { data: registeredOffice, isLoading: registeredOfficeLoading },
    { data: ppb, isLoading: ppbLoading },
  ] = useQueries<Address>({
    queries: [
      {
        apiName: "address",
        path: `/${company.registeredOfficeID}`,
        enabled: !!company.principalPlaceOfBusinessID,
        queryKey: getQueryKey("registeredOffice", company.registeredOfficeID),
      },
      {
        apiName: "address",
        enabled: !!company.principalPlaceOfBusinessID,
        path: `/${company.principalPlaceOfBusinessID}`,
        queryKey: getQueryKey(
          "principalPlaceOfBusiness",
          company.principalPlaceOfBusinessID,
        ),
      },
    ],
  });

  return {
    ppb,
    ppbItems: getAddressItems(ppb),
    ppbLoading,
    registeredOffice,
    registeredOfficeItems: getAddressItems(registeredOffice),
    registeredOfficeLoading,
  };
};

export const useShareCapital = (companyID: number) => {
  const queryKey = getQueryKey("companyShareCapital", companyID);

  const { data = [], isLoading } = useQuery<ShareCapital[]>({
    apiName: "company",
    path: `/${companyID}/share-capital`,
    queryKey,
  });

  return {
    data,
    isLoading,
    queryKey,
  };
};
